import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../hooks';
import { editSchedule } from '../actions/EditSchedule';
import { ScheduleTime } from '../features/schedules/ScheduleTime';
import { ScheduleOperation } from '../features/schedules/ScheduleOperation';
import { ScheduleNextRun } from '../features/schedules/ScheduleNextRun';
import { DialogScheduleEdit } from '../components/DialogScheduleEdit';
import { newSchedule } from '../actions/NewSchedule';
import { allSchedules } from '../features/schedules/schedulesSlice';
import { subscribeEntities } from '../reducers/entitiesSlice';
import { EntityOnOff } from './EntityOnOff';
import { EntityOnOffUnknown } from './EntityOnOffUnknown';
import { EntityLevel } from './EntityLevel';
import { EntityColorTemperature } from './EntityColorTemperature';
import { EntityNexaDim } from './EntityNexaDim';
import { EntityHasta } from './EntityHasta';
import { selectWidgetForDevice } from '../reducers/SelectWidgetForDevice';
import { selectDevice } from '../features/devices/devicesSlice';
import { EntityTemperature } from './EntityTemperature';
import { EntityHumidity } from './EntityHumidity';
const DeviceSchedule = props => {
    const dispatch = useAppDispatch();
    const schedules = useAppSelector(state => allSchedules(state.definitions.schedules));
    const schemaRows = [];
    for (const s of schedules) {
        if (s && s.device_id == props.device) {
            schemaRows.push(_jsxs("div", { className: "config-schedule-row", children: [_jsx("div", { style: { whiteSpace: 'nowrap' }, children: _jsx(ScheduleTime, Object.assign({}, s.time)) }), _jsx(ScheduleNextRun, { schedule: s }), _jsx(ScheduleOperation, { schedule: s }), _jsx("div", { children: _jsx("button", { className: "edit lw small", onClick: () => dispatch(editSchedule(s.id)), children: "\u00A0Redigera\u00A0" }) })] }, s.id));
        }
    }
    return (_jsxs(React.Fragment, { children: [_jsxs("div", { children: [_jsx("button", { style: { float: 'right' }, className: "addschedule lw success", onClick: () => dispatch(newSchedule(props.device)), children: "Ny schemal\u00E4ggning" }), _jsx("h3", { style: { marginTop: '3em' }, children: "Schemal\u00E4ggning" })] }), _jsx("div", { className: "device-schedule-config", style: { marginLeft: '15px' }, children: _jsxs("div", { className: "config-rows device-schedules", children: [_jsxs("div", { className: "config-schedule-row header", children: [_jsx("div", { style: { whiteSpace: 'nowrap' }, children: "Tidpunkt" }), _jsx("div", { children: "N\u00E4sta" }), _jsx("div", { style: { whiteSpace: 'nowrap' }, children: "Operation" }), _jsx("div", {})] }), schemaRows] }) })] }));
};
export const Device = props => {
    var _a, _b, _c;
    const dispatch = useAppDispatch();
    const device = useAppSelector(state => selectDevice(state, props.id));
    const widget = useAppSelector(state => selectWidgetForDevice(state, props.id));
    let device2;
    const deviceEntities = [];
    function subscribe(v) { if (v != undefined) {
        deviceEntities.push(v);
    } }
    let hasSchedule = true;
    switch (widget === null || widget === void 0 ? void 0 : widget.kind) {
        case 'NexaDimmer':
            device2 = _jsxs(_Fragment, { children: [_jsx(EntityNexaDim, { entity: widget.entity, actionOnOff: widget.actionOnOff, actionLevel: widget.actionLevel }), _jsx("div", { style: { paddingTop: '10px' } })] });
            subscribe(widget.entity);
            break;
        case 'Light':
            device2 = _jsxs(_Fragment, { children: [widget.onoff ? (_jsx(EntityOnOff, { entity: widget.onoff.entity, action: widget.onoff.action })) : null, widget.onoff ? (_jsx("div", { style: { paddingTop: '10px' } })) : null, widget.level ? (_jsx(EntityLevel, { entity: widget.level.entity, action: widget.level.action })) : null, widget.colorTemperature ? (_jsx(EntityColorTemperature, { entity: widget.colorTemperature.entity, action: widget.colorTemperature.action })) : null] });
            subscribe((_a = widget.onoff) === null || _a === void 0 ? void 0 : _a.entity);
            subscribe((_b = widget.level) === null || _b === void 0 ? void 0 : _b.entity);
            subscribe((_c = widget.colorTemperature) === null || _c === void 0 ? void 0 : _c.entity);
            break;
        case 'OnOffUnknown':
            device2 = (_jsx(EntityOnOffUnknown, { entity: widget.entity, action: widget.action }));
            subscribe(widget.entity);
            break;
        case 'Shades':
            device2 = (_jsx(EntityHasta, { entity: widget.entity, action: widget.action }));
            subscribe(widget.entity);
            break;
        case 'Thermometer':
            device2 = _jsxs(_Fragment, { children: ["Temperatur: ", _jsx(EntityTemperature, { entity: widget.temp }), widget.humid ? (_jsxs("div", { children: ["Luftfuktighet: ", _jsx(EntityHumidity, { entity: widget.humid })] })) : null] });
            subscribe(widget.temp);
            if (widget.humid)
                subscribe(widget.humid);
            hasSchedule = false;
            break;
    }
    useEffect(() => subscribeEntities(dispatch, deviceEntities), [deviceEntities]);
    if (device == undefined || device2 == undefined) {
        return (_jsx("div", { children: "Unknown device" }));
    }
    return (_jsxs(React.Fragment, { children: [_jsx(DialogScheduleEdit, { device_id: device.id }), _jsx("h1", { children: device.title }), device2, hasSchedule ? _jsx(DeviceSchedule, { device: device.id }) : null] }));
};
